// extracted by mini-css-extract-plugin
module.exports = {"iconTrayWrapper":"iconTrayWrapper--hBbWN","attachmentsWrapper":"attachmentsWrapper--kO2BG"};